export default "__VITE_ASSET__9f9c22ac__"